// extracted by mini-css-extract-plugin
export default {"task-list":"task-list_task-list__NjX0t","tasks":"task-list_tasks__XO53e","counter":"task-list_counter__9Ylki"};